import sc from 'styled-components';
import {Button} from '@phonectas/unifon-ui-kit';

export const StyledNavUl = sc.ul`
    margin: 0;
    padding: 0;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: stretch;
    list-style: none;
    width: auto;
    gap: 5px;
    flex-wrap: nowrap;
`;

export const StyledNavLi = sc.li`
    display: inline-block;
    list-style: none;
    margin: 0px 0.05%;
    cursor: pointer;
    width: 100%;
`;

export const StyledButtonGroup = sc(Button)`
    width: 100%;
    background-color: rgba(243, 243, 245, 0.7);
    user-select: none;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
        background-color: rgb(201, 201, 201);
    }
`;

export const DropdownWrapper = sc.div`
    position: relative;
    overflow: visible;
`;

export const StyledDropdownUl = sc.ul`
    transition: opacity 0.3s ease, transform 0.3s ease;
    position: absolute;
    z-index: 9999;
    top: 5px;
    right: 0;
    left: auto;
    margin: 0;
    padding: 0.5rem;
    list-style: none;
    border-radius: 5px;
    background-color: white;
    transform-origin: top;
    user-select: none;
    opacity: 1;
    transform: scaleY(1);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);

    li {
        padding: 0 15px;
        line-height: 45px;
        overflow: hidden;
        cursor: pointer;

    &:hover {
         background-color: #F3F3F5;
        border-radius: 10px;
    }
  }
`;